/* esm.sh - mdast-util-gfm-table@2.0.0 */
export * from "/*mdast-util-gfm-table@2.0.0/esnext/mdast-util-gfm-table.mjs";
